<template>
  <v-container fluid id="truckRequests" class="pa-0 pa-sm-3">
    <v-row wrap justify="center">
      <v-col cols="12" xs="12" class="headline pb-0"
        >Truck Requests
        <v-btn
          small
          color="primary"
          class="mx-4"
          @click.stop="
            scheduleDialog = true;
            generateScheduledDays();
            2;
          "
          :disabled="!selectedtruckRequests.length"
        >
          <v-icon left small>today</v-icon>Schedule
        </v-btn>
        <v-btn color="primary" small :to="'/truck-requests/scheduler-v2'"
          ><v-icon small left>drag_indicator</v-icon> Drag and Drop</v-btn
        >
      </v-col>
      <v-col align="right">
        <!-- FINAL REVIEW -->

        <!-- SCHEDULE DIALOG -->
        <v-dialog v-model="scheduleDialog" max-width="95%" persistent>
          <v-card>
            <v-card-title class="headline" primary-title
              >Final Review
            </v-card-title>
            <v-card-text>
              <v-container fluid class="pa-0 mb-2">
                <v-row no-gutters>
                  <v-col cols="12" sm="12" md="3" class="ml-0 align-left">
                    <v-select
                      hide-details
                      label="Select date"
                      v-model="scheduledDay"
                      :items="scheduledDayOptions"
                      item-value="displayDate"
                      item-text="displayDate"
                      return-object
                      color="primary"
                      outlined
                      dense
                    ></v-select>
                  </v-col>
                </v-row>
              </v-container>
              <v-card class="elevation-0">
                <v-simple-table
                  class="pb-4 grey lighten-4 pt-2 mt-4"
                  dense
                  id="truckRequestsSchedule"
                >
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <td width="220">
                          <span class="caption grey--text">Job</span>
                        </td>
                        <td align="left">
                          <span class="caption grey--text">DETAILS</span>
                        </td>
                        <td align="left">
                          <span class="caption grey--text">TIME</span>
                        </td>
                        <td>
                          <span class="caption grey--text">Duration</span>
                        </td>
                        <td align="left">
                          <span class="caption grey--text">DRIVER</span>
                        </td>
                        <td align="left">
                          <span class="caption grey--text">NOTES</span>
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="order in selectedtruckRequestsSorted"
                        :key="order.orderNumber"
                      >
                        <td align="left">
                          <strong class="primary--text">
                            {{ order.jobSite.street }}
                            <div class="caption">
                              ({{ order.jobSite.jobId }})
                            </div>
                          </strong>
                          <div class="caption grey--text">
                            {{ order.requestDate | moment("MMM Do") }}
                            <span v-if="order.requestTime">
                              at {{ order.requestTime }}
                            </span>
                          </div>
                        </td>
                        <td align="left" class="scheduleDetails">
                          <truck-request-details
                            :order="order"
                            :showNotes="true"
                          />
                        </td>
                        <td align="left" width="160">
                          <v-select
                            v-model="order.scheduledTime"
                            hide-details
                            :items="[
                              '12:15am',
                              '12:30am',
                              '12:45am',
                              '1:00am',
                              '1:15am',
                              '1:30am',
                              '1:45am',
                              '2:00am',
                              '2:15am',
                              '2:30am',
                              '2:45am',
                              '3:00am',
                              '3:15am',
                              '3:30am',
                              '3:45am',
                              '4:00am',
                              '4:15am',
                              '4:30am',
                              '4:45am',
                              '5:00am',
                              '5:15am',
                              '5:30am',
                              '5:45am',
                              '6:00am',
                              '6:15am',
                              '6:30am',
                              '6:45am',
                              '7:00am',
                              '7:15am',
                              '7:30am',
                              '7:45am',
                              '8:00am',
                              '8:15am',
                              '8:30am',
                              '8:45am',
                              '9:00am',
                              '9:15am',
                              '9:30am',
                              '9:45am',
                              '10:00am',
                              '10:15am',
                              '10:30am',
                              '10:45am',
                              '11:00am',
                              '11:15am',
                              '11:30am',
                              '11:45am',
                              '12:00pm',
                              '12:15pm',
                              '12:30pm',
                              '12:45pm',
                              '1:00pm',
                              '1:15pm',
                              '1:30pm',
                              '1:45pm',
                              '2:00pm',
                              '2:15pm',
                              '2:30pm',
                              '2:45pm',
                              '3:00pm',
                              '3:15pm',
                              '3:30pm',
                              '3:45pm',
                              '4:00pm',
                              '4:15pm',
                              '4:30pm',
                              '4:45pm',
                              '5:00pm',
                              '5:15pm',
                              '5:30pm',
                              '5:45pm',
                              '6:00pm',
                              '6:15pm',
                              '6:30pm',
                              '6:45pm',
                              '7:00pm',
                              '7:15pm',
                              '7:30pm',
                              '7:45pm',
                              '8:00pm',
                              '8:15pm',
                              '8:30pm',
                              '8:45pm',
                              '9:00pm',
                              '9:15pm',
                              '9:30pm',
                              '9:45pm',
                              '10:00pm',
                            ]"
                            type="text"
                            color="primary"
                            dense
                            outlined
                          ></v-select>
                        </td>
                        <td align="left" width="200">
                          <v-select
                            hide-details
                            v-model="order.scheduledDuration"
                            :items="[
                              '15 Minutes',
                              '30 Minutes',
                              '45 Minutes',
                              '1 Hour',
                              '1 Hour & 15 Minutes',
                              '1 Hour & 30 Minutes',
                              '1 Hour & 45 Minutes',
                              '2 Hours',
                              '2 Hour & 15 Minutes',
                              '2 Hour & 30 Minutes',
                              '2 Hour & 45 Minutes',
                              '3 Hours',
                              '3 Hour & 15 Minutes',
                              '3 Hour & 30 Minutes',
                              '3 Hour & 45 Minutes',
                              '4 Hours',
                              '4 Hour & 15 Minutes',
                              '4 Hour & 30 Minutes',
                              '4 Hour & 45 Minutes',
                              '5 Hours',
                              '5 Hour & 15 Minutes',
                              '5 Hour & 30 Minutes',
                              '5 Hour & 45 Minutes',
                              '6 Hours',
                              '6 Hour & 15 Minutes',
                              '6 Hour & 30 Minutes',
                              '6 Hour & 45 Minutes',
                              'All Afternoon',
                              'All Day',
                            ]"
                            type="text"
                            class
                            color="primary"
                            outlined
                            dense
                          ></v-select>
                        </td>
                        <td align="left" width="160">
                          <v-select
                            v-model="order.scheduledDriver"
                            :items="drivers"
                            return-object
                            item-text="name"
                            type="text"
                            class
                            color="primary"
                            hide-details
                            outlined
                            dense
                          ></v-select>
                        </td>
                        <td align="left" width="260">
                          <v-text-field
                            v-model="order.truckManagerNotes"
                            type="text"
                            class
                            color="primary"
                            hide-details
                            outlined
                            dense
                          ></v-text-field>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card>
            </v-card-text>
            <v-card-actions class="pa-2">
              <v-spacer></v-spacer>
              <span
                class="red--text"
                v-if="
                  selectedtruckRequestsSorted &&
                    !selectedtruckRequestsSorted.every(
                      (sr) =>
                        sr.requestDate ===
                        selectedtruckRequestsSorted[0].requestDate
                    )
                "
                >* Not all request days are the same.</span
              >
              <v-btn
                color="primary"
                text
                @click="
                  scheduleDialog = false;
                  selectedtruckRequests = [];
                "
                class="px-4"
                >Cancel</v-btn
              >
              <v-btn
                color="primary"
                @click="submitTruckSchedule"
                :disabled="!scheduledDay || submittingTruckSchedule"
                class="px-4"
                ><v-icon left small>email</v-icon> Send</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- END FINAL REVIEW -->
      </v-col>

      <!--  TRUCK REQUESTS -->
      <v-col cols="12" xs="12" class="">
        <v-card>
          <v-tabs>
            <v-tab
              @click="
                orderType = 'truckRequestsOpen';
                page = 1;
              "
            >
              Open
              <span class="caption ml-1 grey--text"
                >({{ truckRequestsOpen.length }})</span
              >
            </v-tab>
            <v-tab
              @click="
                orderType = 'truckRequestsScheduled';
                page = 1;
              "
              >Scheduled
              <span class="caption ml-1 grey--text"
                >({{ truckRequestsScheduled.length }})</span
              >
            </v-tab>
            <v-tab
              @click="
                orderType = 'truckRequestsClosed';
                page = 1;
              "
              >Closed</v-tab
            >
            <v-tab
              @click="
                orderType = 'truckRequestsCancelled';
                page = 1;
              "
              >Cancelled</v-tab
            >
            <v-tab
              @click="
                orderType = 'truckRequestsMissingDump';
                page = 1;
              "
              >Missing Dump
              <span class="caption ml-1 grey--text"
                >({{ truckRequestsMissingDump.length }})</span
              ></v-tab
            >
          </v-tabs>
          <v-divider></v-divider>
          <v-data-table
            :items="currentTruckRequestType"
            :loading="loadingTruckRequests"
            loading-text="Loading....please wait."
            :headers="computedHeaders"
            :items-per-page="80"
            show-select
            dense
            v-model="selectedtruckRequests"
          >
            <template v-slot:header.data-table-select="{ item }"></template>
            <template
              v-slot:item.data-table-select="{ isSelected, select, item }"
            >
              <v-checkbox
                :input-value="isSelected"
                @change="select($event)"
                v-if="item && item.status === 'open'"
              ></v-checkbox>
            </template>
            <template v-slot:item.orderNumber="{ item }">
              <span class="subtitle-2">#{{ item.orderNumber }}</span>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon
                    color="amber"
                    small
                    class="ml-1"
                    v-if="
                      ['scheduled', 'closed'].includes(item.status) &&
                        !item.dumpTickets &&
                        item.requestType !== 'Mini Pickup/Dropoff' &&
                        item.pickupType !== 'Drop Off Container'
                    "
                    v-on="on"
                    >error</v-icon
                  >
                </template>
                <span>Missing Dump Ticket</span>
              </v-tooltip>
            </template>
            <template v-slot:item.requestDate="{ item }">
              {{ item.requestDate | moment("MMM Do") }}
              <div v-if="item.requestTime">at {{ item.requestTime }}</div>
              <div v-if="item.scheduledDay" class="caption green--text">
                {{ item.scheduledDay.displayDate }}<br />
                {{ item.scheduledTime }}<br />
              </div>
            </template>
            <template v-slot:item.address="{ item }">
              {{ item.jobSite.street }}
              <div class="caption">({{ item.jobSite.jobId }})</div>
              <div class="h6 grey--text" v-if="item.jobSite.client">
                [{{ item.jobSite.client.name }}]
              </div>
            </template>
            <template v-slot:item.requestType="{ item }">
              <truck-request-details :showNotes="true" :order="item" />
            </template>
            <template v-slot:item.orderedBy="{ item }">
              {{ item.orderedBy.firstName }}
              {{ item.orderedBy.lastName }}
              <div class="grey--text caption">
                {{ item.orderDate.toDate() | moment("MMM Do [at] h:mmA") }}
              </div>
            </template>
            <template v-slot:item.status="{ item }">
              <status-chip :status="item.status" />
            </template>
            <template v-slot:item.scheduledDriver.firstName="{ item }">
              <v-select
                v-if="item.status == 'open'"
                :items="drivers"
                v-model="item.draftDriver"
                return-object
                item-text="name"
                dense
                hide-details
                @change="updateAssignedTruckDraft(item)"
              ></v-select>
              <v-select
                v-if="item.status == 'scheduled'"
                :items="drivers"
                v-model="item.scheduledDriver"
                return-object
                item-text="name"
                label="Driver"
                hide-details
                @change="updateAssignedTruck(item)"
              ></v-select>
              <span
                v-if="
                  (item.status === 'closed' || item.status === 'cancelled') &&
                    item.scheduledDriver
                "
                >{{ item.scheduledDriver.firstName }}
                {{ item.scheduledDriver.lastName }}</span
              >
            </template>
            <template v-slot:item.time="{ item }">
              <v-select
                dense
                v-if="item.status === 'open'"
                :items="[
                  '12:15am',
                  '12:30am',
                  '12:45am',
                  '1:00am',
                  '1:15am',
                  '1:30am',
                  '1:45am',
                  '2:00am',
                  '2:15am',
                  '2:30am',
                  '2:45am',
                  '3:00am',
                  '3:15am',
                  '3:30am',
                  '3:45am',
                  '4:00am',
                  '4:15am',
                  '4:30am',
                  '4:45am',
                  '5:00am',
                  '5:15am',
                  '5:30am',
                  '5:45am',
                  '6:00am',
                  '6:15am',
                  '6:30am',
                  '6:45am',
                  '7:00am',
                  '7:15am',
                  '7:30am',
                  '7:45am',
                  '8:00am',
                  '8:15am',
                  '8:30am',
                  '8:45am',
                  '9:00am',
                  '9:15am',
                  '9:30am',
                  '9:45am',
                  '10:00am',
                  '10:15am',
                  '10:30am',
                  '10:45am',
                  '11:00am',
                  '11:15am',
                  '11:30am',
                  '11:45am',
                  '12:00pm',
                  '12:15pm',
                  '12:30pm',
                  '12:45pm',
                  '1:00pm',
                  '1:15pm',
                  '1:30pm',
                  '1:45pm',
                  '2:00pm',
                  '2:15pm',
                  '2:30pm',
                  '2:45pm',
                  '3:00pm',
                  '3:15pm',
                  '3:30pm',
                  '3:45pm',
                  '4:00pm',
                  '4:15pm',
                  '4:30pm',
                  '4:45pm',
                  '5:00pm',
                  '5:15pm',
                  '5:30pm',
                  '5:45pm',
                  '6:00pm',
                  '6:15pm',
                  '6:30pm',
                  '6:45pm',
                  '7:00pm',
                  '7:15pm',
                  '7:30pm',
                  '7:45pm',
                  '8:00pm',
                  '8:15pm',
                  '8:30pm',
                  '8:45pm',
                  '9:00pm',
                  '9:15pm',
                  '9:30pm',
                  '9:45pm',
                  '10:00pm',
                ]"
                v-model="item.draftTime"
                hide-details
                @change="updateRequestTimeDraft(item)"
              ></v-select>
            </template>
            <template v-slot:item.duration="{ item }">
              <v-select
                dense
                v-if="item.status === 'open'"
                :items="[
                  '15 Minutes',
                  '30 Minutes',
                  '45 Minutes',
                  '1 Hour',
                  '1 Hour & 15 Minutes',
                  '1 Hour & 30 Minutes',
                  '1 Hour & 45 Minutes',
                  '2 Hours',
                  '2 Hour & 15 Minutes',
                  '2 Hour & 30 Minutes',
                  '2 Hour & 45 Minutes',
                  '3 Hours',
                  '3 Hour & 15 Minutes',
                  '3 Hour & 30 Minutes',
                  '3 Hour & 45 Minutes',
                  '4 Hours',
                  '4 Hour & 15 Minutes',
                  '4 Hour & 30 Minutes',
                  '4 Hour & 45 Minutes',
                  '5 Hours',
                  '5 Hour & 15 Minutes',
                  '5 Hour & 30 Minutes',
                  '5 Hour & 45 Minutes',
                  '6 Hours',
                  '6 Hour & 15 Minutes',
                  '6 Hour & 30 Minutes',
                  '6 Hour & 45 Minutes',
                  'All Afternoon',
                  'All Day',
                ]"
                v-model="item.draftDuration"
                hide-details
                @change="updateRequestDurationDraft(item)"
              ></v-select>
            </template>
            <template v-slot:item.details="{ item }">
              <v-btn
                color="primary"
                class="mb-1"
                small
                outlined
                text
                @click.stop="showTicket(item)"
                >Details</v-btn
              >
              <v-btn
                v-if="item.status == 'scheduled'"
                class="ml-1 mb-1"
                color="primary"
                small
                outlined
                text
                :to="`/truck-requests/manage/orders/${item.orderNumber}`"
                >Close</v-btn
              >
            </template>
            <template v-slot:item.options="{ item }">
              <v-menu
                bottom
                left
                v-if="!['cancelled', 'closed'].includes(item.status)"
              >
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>

                <v-list>
                  <v-list-item
                    v-for="o in requestOptions"
                    :key="o.title"
                    @click="requestOption(o, item)"
                  >
                    <v-list-item-title>{{ o.title }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-menu bottom left v-if="item.status === 'closed'">
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>

                <v-list>
                  <v-list-item @click="duplicateAsDriver(item)">
                    <v-list-item-title>Duplicate As Driver</v-list-item-title>
                  </v-list-item>
                </v-list>
                <v-list-item
                  :to="`/truck-requests/manage/orders/${item.orderNumber}`"
                >
                  <v-list-item-title>Edit Closed Request</v-list-item-title>
                </v-list-item>
              </v-menu>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" width="500" persistent>
      <truck-request-ticket
        :truckRequest="currentTicket"
        @close="closeTicket"
        :showClose="true"
      />
    </v-dialog>
    <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
      {{ snackText }}
      <v-btn text @click="snack = false">Close</v-btn>
    </v-snackbar>
    <v-dialog ref="dialog" v-model="modal.show" persistent>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="modal.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title
          >Driver View:
          {{
            orderType == "truckRequestsOpen" ? "Drafted" : "Scheduled"
          }}</v-toolbar-title
        >
      </v-toolbar>
      <v-sheet class="mx-auto" elevation="8">
        <v-row class="pa-4">
          <v-col cols="12" md="4" offset-md="4">
            <v-menu
              ref="menu"
              v-model="modal.menu"
              :close-on-content-click="false"
              :return-value.sync="modal.date"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="modalFormattedDate"
                  label="Scheduled Date"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  required
                ></v-text-field>
              </template>
              <v-date-picker v-model="modal.date" scrollable color="primary">
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  @click="
                    $refs.menu.save(modal.date);
                    buildDataByDriver();
                  "
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-slide-group class="pa-4" show-arrows>
          <v-slide-item v-for="n in modal.headersFiltered" :key="n" flat>
            <v-card class="ma-4" width="180">
              <v-list-item three-line>
                <v-list-item-content>
                  <div class="text-overline mb-4" style="line-height: 1rem;">
                    {{ n }}
                  </div>
                  <div
                    v-for="d in modal.dataFiltered[n]"
                    :key="d.key"
                    class="mb-4 caption"
                    style="border-bottom: 1px solid rgba(0, 0, 0, 0.12);"
                  >
                    <strong>{{ d.jobSiteAddress }}</strong>
                    <br />
                    {{ d.requestTime }}
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-slide-item>
        </v-slide-group>
        <v-row class="pa-4" v-show="!modal.headersFiltered.length">
          <v-col cols="12" md="4" offset-md="4">
            <v-alert outlined type="warning"
              >No drivers
              {{ orderType == "truckRequestsOpen" ? "drafted" : "scheduled" }}
              for this date.</v-alert
            >
          </v-col>
        </v-row>
      </v-sheet>
    </v-dialog>
  </v-container>
</template>
<script>
import fb from "@/main";
import moment from "moment";
import { mapGetters, mapState } from "vuex";
import truckRequestTicket from "@/components/truckRequests/truckRequestTicket";
import truckRequestDetails from "@/components/truckRequests/truckRequestDetails";
import statusChip from "@/components/StatusChip";
import { sortBy, groupBy, uniqBy } from "lodash";
export default {
  components: {
    truckRequestDetails,
    truckRequestTicket,
    statusChip,
  },
  data() {
    return {
      submittingTruckSchedule: false,
      requestOptions: [
        { title: "Duplicate Request" },
        { title: "Edit Request" },
        { title: "Cancel Request" },
      ],
      snack: false,
      snackColor: "",
      snackText: "",
      orderType: "truckRequestsOpen",
      search: "",
      dialog: false,
      scheduleDialog: false,
      editRequestDialog: false,
      newJobSiteDialog: false,
      loadingTruckRequests: true,
      currentTicket: null,
      selectedtruckRequests: [],
      scheduledDay: null,
      scheduledDayOptions: [],
      currentRequest: null,
      numberOfTrucks: null,
      fullLoadsQty: null,
      containerSize: null,
      drivers: [],
      previewData: null,
      modal: {
        menu: false,
        show: false,
        date: moment().format("YYYY-MM-DD"),
        headers: [],
        headersFiltered: [],
        data: [],
        dataFiltered: [],
      },
    };
  },
  computed: {
    ...mapState(["truckRequests"]),
    ...mapGetters([
      "truckRequestsOpen",
      "truckRequestsScheduled",
      "truckRequestsClosed",
      "truckRequestsCancelled",
      "truckRequestsMissingDump",
    ]),
    ...mapState(["user"]),
    currentTruckRequestType() {
      return this[this.orderType];
    },
    selectedtruckRequestsSorted() {
      return sortBy(this.selectedtruckRequests, "requestType");
    },
    computedHeaders() {
      if (this.orderType === "truckRequestsOpen") {
        return [
          {
            text: "Order",
            align: "left",
            value: "orderNumber",
            width: 80,
            sortable: false,
          },
          {
            text: "Request Date",
            value: "requestDate",
            width: 120,
            sortable: true,
          },
          { text: "Job", value: "address", width: 140, sortable: false },
          {
            text: "Details",
            value: "requestType",
            width: 250,
            sortable: false,
          },
          {
            text: "Ordered By",
            value: "orderedBy",
            sortable: false,
            width: 100,
          },
          { text: "Status", value: "status", align: "left", sortable: false },
          {
            text: "Driver",
            value: "scheduledDriver.firstName",
            align: "left",
            width: 200,
            sortable: false,
          },
          {
            text: "Time",
            value: "time",
            align: "left",
            width: 110,
            sortable: false,
          },
          {
            text: "Duration",
            value: "duration",
            align: "left",
            width: 50,
            sortable: false,
          },
          {
            text: "",
            value: "details",
            align: "right",
            width: 100,
            sortable: false,
          },
          {
            text: "",
            value: "options",
            align: "right",
            width: 20,
            sortable: false,
          },
        ];
      } else {
        return [
          {
            text: "Order",
            align: "left",
            value: "orderNumber",
            width: 80,
            sortable: false,
          },
          {
            text: "Request Date",
            value: "requestDate",
            width: 120,
            sortable: true,
          },
          { text: "Job", value: "address", width: 120, sortable: false },
          {
            text: "Details",
            value: "requestType",
            width: 250,
            sortable: false,
          },
          {
            text: "Ordered By",
            value: "orderedBy",
            sortable: false,
            width: 100,
          },
          { text: "Status", value: "status", align: "left", sortable: false },
          {
            text: "Driver",
            value: "scheduledDriver.firstName",
            align: "left",
            width: 200,
            sortable: true,
          },
          {
            text: "",
            value: "details",
            align: "right",
            width: 190,
            sortable: false,
          },
          {
            text: "",
            value: "options",
            align: "right",
            width: 20,
            sortable: false,
          },
        ];
      }
    },
    modalFormattedDate() {
      return this.modal.date
        ? moment(this.modal.date).format("MMMM D YYYY")
        : "";
    },
  },
  async created() {
    if (!this.truckRequests.length) {
      await this.$store.dispatch("getTruckRequests", fb);
    }
    this.loadingTruckRequests = false;
    this.generateScheduledDays();
    this.getDrivers();
  },
  methods: {
    buildDataByDriver() {
      const dateFormat = function(seconds) {
        return new Date(seconds * 1000).toLocaleDateString("en-US");
      };
      const dataByDriver = this.currentTruckRequestType
        .map((s) => {
          const driver = s.scheduledDriver || s.draftDriver || {};
          const scheduledDate =
            (s.scheduledDay || {}).day || s.requestDate || null;
          return {
            driverName: driver.name,
            scheduledDate: scheduledDate,
            requestTime: s.requestTime,
            jobSiteAddress: s.jobSite.address,
            key: `${driver.name}${s.jobSite.address}${s.requestTime}`.replace(
              /\W/g,
              ""
            ),
          };
        })
        .filter((s) => {
          return s.driverName;
        })
        .sort((a, b) => {
          const selectedDate = moment(this.modal.date).format("YYYY-MM-DD");
          const time1 =
            selectedDate +
            " " +
            moment(a.requestTime, ["h:mm A"]).format("HH:mm");
          const time2 =
            selectedDate +
            " " +
            moment(b.requestTime, ["h:mm A"]).format("HH:mm");
          return new Date(time1) - new Date(time2);
        });
      const dataByDriverUnique = uniqBy(dataByDriver, "key");
      const dataGrouped = groupBy(dataByDriverUnique, "driverName");
      this.modal.headers = Object.keys(dataGrouped);
      this.modal.data = dataByDriverUnique;

      const dataFiltered = dataByDriverUnique.filter((s) => {
        const scheduledDate = moment(s.scheduledDate).format("YYYY-MM-DD");
        const selectedDate = moment(this.modal.date).format("YYYY-MM-DD");
        return scheduledDate === selectedDate;
      });
      if (dataFiltered.length) {
        const dataGrouped = groupBy(dataFiltered, "driverName");
        this.modal.dataFiltered = groupBy(dataFiltered, "driverName");
        this.modal.headersFiltered = Object.keys(dataGrouped);
      } else {
        this.modal.dataFiltered = [];
        this.modal.headersFiltered = [];
      }
    },
    async submitTruckSchedule() {
      try {
        if (this.selectedtruckRequests.some((str) => !str.scheduledTime)) {
          alert("Missing Scheduled times.");
          return;
        }
        if (this.selectedtruckRequests.some((str) => !str.scheduledDuration)) {
          alert("Missing Scheduled durations.");
          return;
        }
        if (this.selectedtruckRequests.some((str) => !str.scheduledDriver)) {
          alert("Missing Drivers.");
          return;
        }
        this.submittingTruckSchedule = true;
        var batch = fb.db.batch();
        this.selectedtruckRequests.forEach((tr) => {
          var ref = fb.truckRequests_DB.doc(tr.orderNumber);
          batch.update(ref, {
            status: "scheduled",
            scheduledBy: this.user,
            scheduledDate: fb.timestamp,
            scheduledTime: tr.scheduledTime,
            scheduledDuration: tr.scheduledDuration,
            scheduledDriver: tr.scheduledDriver,
            scheduledDay: this.scheduledDay,
            truckManagerNotes: tr.truckManagerNotes || "",
          });
        });
        await batch.commit();
        const truckRequestEmails = await fb.functions.httpsCallable(
          "truckRequestEmails"
        );
        truckRequestEmails({
          truckRequests: this.selectedtruckRequests,
          emailType: "schedule",
          scheduledDay: this.scheduledDay,
        });
        this.scheduleDialog = false;
        this.snack = true;
        this.snackColor = "success";
        this.snackText = "Successfully scheduled trucks";
        this.selectedtruckRequests = [];
        this.submittingTruckSchedule = false;
      } catch (error) {
        this.submittingTruckSchedule = false;
        this.snack = true;
        this.snackColor = "error";
        this.snackText = "Error submitting truck schedule";
        this.selectedtruckRequests = [];
      }
    },
    closeTicket() {
      this.dialog = false;
    },
    showTicket(ticket) {
      this.currentTicket = null;
      this.currentTicket = { ...ticket };
      this.dialog = true;
    },
    generateScheduledDays() {
      this.scheduledDay = null;
      for (let days = 0; days < 5; days++) {
        let day = moment().add(days, "d");
        this.scheduledDayOptions.push({
          displayDate: day.format("MMM Do (dddd)"),
          displayDate2: day.format("M-D-YY"),
          day: day.format("YYYY-MM-DD"),
        });
      }
      this.selectedtruckRequests.forEach((tr) => {
        if (tr.draftDriver) {
          tr.scheduledDriver = tr.draftDriver;
        }
        if (tr.draftTime) {
          tr.scheduledTime = tr.draftTime;
        }
        if (tr.draftDuration) {
          tr.scheduledDuration = tr.draftDuration;
        }
      });
    },
    async requestOption(option, truckRequest) {
      if (option.title === "Cancel Request") {
        try {
          await fb.db
            .collection("truckRequests")
            .doc(truckRequest.id)
            .update({
              status: "cancelled",
              cancelledBy: this.user,
            });
          this.snack = true;
          this.snackColor = "success";
          this.snackText = "Successfully cancelled request";
        } catch (error) {
          this.snack = true;
          this.snackColor = "Error";
          this.snackText = "Error cancelling request";
        }
      }
      if (option.title === "Duplicate Request") {
        this.$store.commit("reloadTruckRequest", truckRequest);
        this.$router.push("/truck-requests/new");
      }
      if (option.title === "Edit Request") {
        this.$router.push(`/truck-requests/edit/${truckRequest.id}`);
      }
    },
    async getDrivers() {
      // get tool orders
      const resDrivers = await fb.db
        .collection("users")
        .where("role", "==", "Driver")
        .get();
      let drivers = [];
      resDrivers.forEach((d) => {
        drivers.push({
          id: d.id,
          ...d.data(),
        });
      });
      drivers = drivers.map((d) => {
        return { name: `${d.firstName} ${d.lastName}`, ...d };
      });
      drivers = sortBy(drivers, "name");
      this.drivers = drivers;
    },
    async updateAssignedTruck(tr) {
      try {
        await fb.db
          .collection("truckRequests")
          .doc(tr.orderNumber)
          .update({ scheduledDriver: tr.scheduledDriver });
        this.snack = true;
        this.snackColor = "success";
        this.snackText = "Driver updated successfully!";
      } catch (error) {
        this.snack = true;
        this.snackColor = "error";
        this.snackText = `Error: ${error.message}`;
      }
    },
    async updateAssignedTruckDraft(tr) {
      try {
        await fb.db
          .collection("truckRequests")
          .doc(tr.orderNumber)
          .update({ draftDriver: tr.draftDriver });
        this.snack = true;
        this.snackColor = "success";
        this.snackText = "Driver updated successfully!";
      } catch (error) {
        this.snack = true;
        this.snackColor = "error";
        this.snackText = `Error: ${error.message}`;
      }
    },
    async updateRequestTimeDraft(tr) {
      try {
        await fb.db
          .collection("truckRequests")
          .doc(tr.orderNumber)
          .update({ draftTime: tr.draftTime });
        this.snack = true;
        this.snackColor = "success";
        this.snackText = "Time updated successfully!";
      } catch (error) {
        this.snack = true;
        this.snackColor = "error";
        this.snackText = `Error: ${error.message}`;
      }
    },
    async updateRequestDurationDraft(tr) {
      try {
        console.log("1");
        await fb.db
          .collection("truckRequests")
          .doc(tr.orderNumber)
          .update({ draftDuration: tr.draftDuration });
        console.log("2");
        this.snack = true;
        this.snackColor = "success";
        this.snackText = "Time updated successfully!";
      } catch (error) {
        this.snack = true;
        this.snackColor = "error";
        this.snackText = `Error: ${error.message}`;
      }
    },
    async duplicateAsDriver(truckRequest) {
      try {
        const dupe = { ...truckRequest };
        await this.$store.dispatch("duplicateTruckRequest", {
          fb,
          dupe,
        });
        this.snack = true;
        this.snackColor = "success";
        this.snackText = "Duplicate created successfully!";
      } catch (error) {
        this.snack = true;
        this.snackColor = "error";
        this.snackText = "Error duplicating as driver!";
      }
    },
  },
};
</script>

<style>
@media only screen and (min-width: 600px) {
  #truckRequests .v-data-table td,
  #truckRequests .v-data-table th {
    padding: 0 8px !important;
  }
  #truckRequests .v-data-table td {
    font-size: 0.75rem;
  }
}
#truckRequestsSchedule.v-data-table td {
  font-size: 0.675rem !important;
  line-height: 20px !important;
}
.scheduleDetails {
  line-height: 10px;
}
</style>
